import classNames from 'classnames'
import { FieldValues, UseFormRegister } from 'react-hook-form'

import './BasicTextarea.scss'

export interface BasicTextareaProps extends React.InputHTMLAttributes<HTMLTextAreaElement> {
  name: string
  defaultValue?: string
  register?: UseFormRegister<FieldValues>
  inputWrapperClassName?: string
}

export const BasicTextarea: React.FC<BasicTextareaProps> = ({
  name,
  defaultValue,
  register = () => {},
  inputWrapperClassName,
  className,
  ...props
}) => {
  return (
    <div
      className={classNames('basic-textarea-wrapper', inputWrapperClassName)}
    >
      <textarea
        id={name}
        name={name}
        className={classNames('basic-textarea', className)}
        defaultValue={defaultValue}
        aria-label={name}
        aria-multiline
        {...register(name)}
        {...props}
      />
    </div>
  )
}
